module.exports = __webpack_public_path__ + "static/img/img-background-1.24085b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/carousel_background/img-background-1.jpg
// module id = 0cjO
// module chunks = 36